import { Box, Button, ButtonGroup, Menu, MenuItem, ToggleButton, ToggleButtonGroup } from "@mui/material"
import Grid from "@mui/material/Grid2"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import axios from "axios"
import * as React from "react"
import { AXIOS_API_INSTANCE, RENTAL_STATUS_FRIENDLY_NAMES, RENTAL_CONTRACT_COLOR_MAP } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import dayjs from "dayjs"
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop"
import { find_rate_in_group, moneyFormat, rate_calculation, rate_chunks, rate_visualization, specific_rate_calculation } from "../../Utils"
import { useSnackbar } from 'notistack';
import TabPanel from "../../Utils/tabpanel"
import PaymentPage from "../Payment/PaymentPage"
import CustomerAccordion from "../CustomerAccordion"
import ContractItem from "./ContractItem"
import ContractItemData from "./ContractItemData"
import { useTheme } from "@emotion/react"
import ContractEditDateModal from "./modals/ContractEditDateModal"
import ContractAdjustmentModal from "./modals/ContractAdjustmentModal"
import { useNavigate } from "react-router-dom"

export default function Contract({
    order
}) {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [myOrder, setOrder] = React.useState(undefined)
    const [tab, setTab] = React.useState("details")
    const [rentalContractItems, setRentalContractItems] = React.useState({})
    const [myOrderItems, setOrderItems] = React.useState({})
    const [myOrderInvoice, setOrderInvoice] = React.useState()
    const [contractLoadingStep, setContractLoadingStep] = React.useState(0)
    const [contractSavingStep, setContractSavingStep] = React.useState(0)
    const [contractInvoiceStep, setContractInvoiceStep] = React.useState(0)
    // const [openPaymentModal, setOpenPaymentModal] = React.useState(false)
    const [allowEditingHours,] = React.useState(false)
    const [chargedHours, setChargedHours] = React.useState(1)
    const [checkoutTab, setCheckoutTab] = React.useState('data')
    const [checkinTab, setCheckinTab] = React.useState('data')
    const [editingDate, setEditingDate] = React.useState(false)
    const [adjustmentModal, setAdjustmentModal] = React.useState({
        open: false,
        rentalContractItem: {},
    })
    const [invoiceOptionsMenuAnchorElement, setInvoiceOptionsMenuAnchorElement] = React.useState(null);
    const [invoiceOptionsMenuItemOpen, setInvoiceOptionsMenuItemOpen] = React.useState(false);
    const navigate = useNavigate();

    console.log("RENDER CONTRACT")

    const filterCanceledItems = (item) => item.status !== 'CANCELED'
    const buildRentalContractItemUpdate = (item, status) => AXIOS_API_INSTANCE.post(`rentalcontractitems/${item.id}`, { status: status, start_date: dayjs.utc() })

    const updateOdometerReading = (item_id, value, checkout_or_checkin_data) => {
        rentalContractItems[item_id][checkout_or_checkin_data].odometer_reading = value
        setRentalContractItems({ ...rentalContractItems })
    }
    const updateQuestion = (item_id, question_index, answer, checkout_or_checkin_data,) => {
        rentalContractItems[item_id][checkout_or_checkin_data].questions[question_index].answer = answer
        setRentalContractItems({ ...rentalContractItems })
    }
    const updateFeeOptional = (item_id, fee_id, value) => {
        rentalContractItems[item_id].fees_data[fee_id].optional_selection = value
        setRentalContractItems({ ...rentalContractItems })
    }
    const updateFeeRefunded = (item_id, fee_id, value) => {
        rentalContractItems[item_id].fees_data[fee_id].refunded = value
        setRentalContractItems({ ...rentalContractItems })
    }
    const editOrderTime = () => {
        setEditingDate(true)
    }
    const closeEditDateModal = (changedOrder) => {
        if (changedOrder) {
            setOrder(changedOrder)
            processOrder(changedOrder)
        }
        setEditingDate(false)
    }
    const closeEditQuantityModal = (changedOrder) => {
        if (changedOrder) {
            setOrder(undefined)
        }
    }
    const closeAdjustmentModal = (changedOrder) => {
        if (changedOrder) {
            setOrder(undefined)
        }
        setAdjustmentModal({ open: false, rentalContractItem: {}, })
    }
    const openInvoiceOptionsMenu = (event) => {
        setInvoiceOptionsMenuAnchorElement(event.currentTarget.parentElement)
        setInvoiceOptionsMenuItemOpen(true)
    }

    const checkout_update = () => {
        setContractSavingStep(1)
        const checkOutObject = {
            action: 'UPDATE',
            // rental_contract: cleanedOrder,
            rental_contract_items: rentalContractItems
        }
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontracts/${myOrder.id}/check_out`, checkOutObject).then((rentalContract) => {
            console.log(rentalContract);
            setContractSavingStep(0)
            enqueueSnackbar('Successfully updated contract', { variant: 'success' })
            setOrder({ ...myOrder, ...rentalContract.data.data })
            processOrder({ ...myOrder, ...rentalContract.data.data })
        }).catch((error) => {
            console.log(error);
            setContractSavingStep(0)
            enqueueSnackbar(`Failed to update contract: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
        }))
    }
    const checkout_complete = () => {
        setContractSavingStep(1)
        let cleanedOrder = { ...myOrder }
        delete cleanedOrder.rental_contract_items
        const checkOutObject = {
            action: 'COMPLETE',
            rental_contract: cleanedOrder,
            rental_contract_items: rentalContractItems
        }
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontracts/${myOrder.id}/check_out`, checkOutObject).then((rentalContract) => {
            console.log(rentalContract);
            setContractSavingStep(0)
            enqueueSnackbar('Successfully updated contract', { variant: 'success' })
            setOrder(undefined)
            setTab("details")
        }).catch((error) => {
            console.log(error);
            setContractSavingStep(0)
            enqueueSnackbar(`Failed to update contract: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
        }))
    }

    const checkin_start = () => {
        setContractSavingStep(1)
        const checkInObject = {
            action: 'START',
            hours_charged: chargedHours
        }
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontracts/${myOrder.id}/check_in`, checkInObject).then((rentalContract) => {
            console.log(rentalContract);
            setContractSavingStep(0)
            enqueueSnackbar('Successfully updated contract', { variant: 'success' })
            setOrder({ ...myOrder, ...rentalContract.data.data })
            processOrder({ ...myOrder, ...rentalContract.data.data })
        }).catch((error) => {
            console.log(error);
            setContractSavingStep(0)
            enqueueSnackbar(`Failed to update contract: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
        }))
    }
    const checkin_update = () => {
        setContractSavingStep(1)
        const checkInObject = {
            action: 'UPDATE',
            // rental_contract: cleanedOrder,
            rental_contract_items: rentalContractItems
        }
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontracts/${myOrder.id}/check_in`, checkInObject).then((rentalContract) => {
            console.log(rentalContract);
            setContractSavingStep(0)
            enqueueSnackbar('Successfully updated contract', { variant: 'success' })
            setOrder({ ...myOrder, ...rentalContract.data.data })
            processOrder({ ...myOrder, ...rentalContract.data.data })
        }).catch((error) => {
            console.log(error);
            setContractSavingStep(0)
            enqueueSnackbar(`Failed to update contract: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
            setOrder(undefined)
        }))
    }
    const checkin_complete = () => {
        setContractSavingStep(1)
        let cleanedOrder = { ...myOrder }
        delete cleanedOrder.rental_contract_items
        const checkInObject = {
            action: 'COMPLETE',
            rental_contract: cleanedOrder,
            rental_contract_items: rentalContractItems
        }
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontracts/${myOrder.id}/check_in`, checkInObject).then((rentalContract) => {
            console.log(rentalContract);
            setContractSavingStep(0)
            enqueueSnackbar('Successfully updated contract', { variant: 'success' })
            setOrder({ ...myOrder, ...rentalContract.data.data })
            processOrder({ ...myOrder, ...rentalContract.data.data })
        }).catch((error) => {
            console.log(error);
            setContractSavingStep(0)
            enqueueSnackbar(`Failed to update contract: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
            setOrder(undefined)
        }))
    }

    const cancelItem = (item) => {
        setContractSavingStep(2)
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontractitems/${item}`, { status: 'CANCELED' }).then((rentalContractItem) => {
            console.log(rentalContractItem)
            enqueueSnackbar('Successfully canceled item', { variant: 'success' })
            setContractSavingStep(0)
            setOrder(undefined)
        }))
    }
    const cancelOrder = () => {
        // TODO: Improve this to not be a series of API calls that can fail, but combined into one or some how cleaner
        setContractSavingStep(1)
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`rentalcontracts/${myOrder.id}`, { status: 'CANCELED' }).then((rentalContract) => {
            console.log(rentalContract);
            setContractSavingStep(2)
            send_authorized_request(() => axios.all(
                myOrder.rental_contract_items.filter(filterCanceledItems).map((item) => buildRentalContractItemUpdate(item, 'CANCELED'))).then(axios.spread((...rentalContractItems) => {
                    console.log(rentalContractItems)
                    enqueueSnackbar('Successfully canceled order', { variant: 'success' })
                    setContractSavingStep(0)
                    setOrder(undefined)
                })))
        }))
    }

    const generatePdf = () => {
        setContractInvoiceStep(1)
        send_authorized_request(() => AXIOS_API_INSTANCE.get(`rentalcontracts/${myOrder.id}/invoices/${myOrderInvoice.id}/print_invoice`).then((pdf) => {
            var byteCharacters = atob(pdf.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], { type: 'application/pdf;base64' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setContractInvoiceStep(0)
        }).catch((error) => {
            setContractInvoiceStep(0)
            enqueueSnackbar(`Failed to generate invoice <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
        }))
    }

    const paymentUpdate = (changes) => {
        if (changes) {
            setOrder(undefined)
        }
    }

    const getRentalItem = (id) => {
        return AXIOS_API_INSTANCE.get(`rentalitems/${id}`)
    }

    const processOrder = (rentalContract) => {
        setOrderInvoice(rentalContract.rental_contract_invoice)
        let my_rentalContractItems = {}
        for (const rental_contract_item_index in rentalContract.rental_contract_items) {
            const rental_contract_item = rentalContract.rental_contract_items[rental_contract_item_index]
            my_rentalContractItems[rental_contract_item.id.toString()] = {
                checkout_data: rental_contract_item.checkout_data,
                checkin_data: rental_contract_item.checkin_data,
                fees_data: {},
                status: rental_contract_item.status
            }
            for (const rental_contract_item_charge_index in rental_contract_item.rental_contract_item_charges) {
                const rental_contract_item_charge = rental_contract_item.rental_contract_item_charges[rental_contract_item_charge_index]
                if (rental_contract_item_charge.charge_type === 'FEE') {
                    my_rentalContractItems[rental_contract_item.id.toString()]["fees_data"][rental_contract_item_charge.fee_id.toString()] = {
                        refundable: rental_contract_item_charge.refundable,
                        refunded: rental_contract_item_charge.refunded,
                        optional: rental_contract_item_charge.optional,
                        optional_selection: rental_contract_item_charge.optional_selection
                    }
                }
            }
        }
        // Eliminate circular reference by JSON stringifying
        setRentalContractItems(JSON.parse(JSON.stringify(my_rentalContractItems)))
        if (!allowEditingHours) {
            setChargedHours(Math.ceil((dayjs.utc() - dayjs.utc(rentalContract.start_date)) / 1000 / 60 / 60))
        }
        if (rentalContract.rental_contract_items.filter((orderItem) => !(orderItem.rental_item_id in myOrderItems)).length > 0) {
            send_authorized_request(() => axios.all(
                rentalContract.rental_contract_items.map((orderItem) => getRentalItem(orderItem.rental_item_id))).then(axios.spread((...rentalItems) => {
                    console.log(rentalItems)
                    setContractLoadingStep(0)
                    setOrderItems(Object.assign({}, ...rentalItems.map((item) => { return { [item.data.data.id]: item.data.data } })))
                    // const rental_items_map = Object.assign({}, ...rentalItems.map((item) => { return { [item.data.data.id]: item.data.data } }))
                })))
        } else {
            setContractLoadingStep(0)
        }
    }

    const getData = () => {
        setContractLoadingStep(1)
        send_authorized_request(() => AXIOS_API_INSTANCE.get(`rentalcontracts/${order}`).then((rentalContract) => {
            console.log(rentalContract);
            setContractLoadingStep(2)
            setOrder(rentalContract.data.data)
            processOrder(rentalContract.data.data)
        }).catch((error) => {
            console.log(error);
            enqueueSnackbar(`Failed to load contract: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
            navigate('/Contracts')
        }))
    }

    React.useEffect(() => {
        if (contractLoadingStep === 0 && myOrder === undefined) {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myOrder])

    const order_total = myOrder ? myOrderInvoice.total_cost || myOrder.rental_contract_items.filter(filterCanceledItems).reduce((accumulator, item) => accumulator + item.calculated_posttax_total, 0) : 0
    const deposit_total = myOrder ? myOrderInvoice.deposit : 0
    const calculated_start_date = dayjs.utc(myOrder?.start_date ?? myOrder?.estimated_start_date)
    const calculated_end_date = dayjs.utc(myOrder?.end_date ?? myOrder?.estimated_end_date)

    if (myOrder !== undefined) {
        myOrder.rental_contract_items.forEach((item) => {
            const rate_group = find_rate_in_group(item.cost_calculation.rental_rate_group.rental_rates, item.quantity)
            item.calculated_final_duration_hours = Math.ceil((calculated_end_date - calculated_start_date) / 1000 / 60 / 60)
            item.calculated_rate = specific_rate_calculation(rate_group.rental_rates, item.calculated_final_duration_hours, item.quantity)
            item.calculated_rate_visualization = rate_visualization(rate_chunks(rate_calculation(rate_group.rental_rates)[0]), 20, item.calculated_final_duration_hours)
            let total = item.calculated_rate
            // Get fees
            total += item.rental_contract_item_charges.map((charge) => {
                const value = charge.actual_cost ?? charge.estimated_cost
                switch (charge.charge_type) {
                    case 'FEE':
                        return ((!charge.optional || charge.optional_selection) && (!charge.refundable || !charge.refunded)) ? value : 0
                    case 'ADJUSTMENT':
                        return value
                    default:
                        return 0;
                }
            }).reduce((a, b) => a + b, 0)
            console.log(total)
            item.calculated_pretax_total = total
            item.calculated_tax = ((parseInt(item.cost_calculation.location_tax_rate) || 0) / 100) * item.calculated_pretax_total
            item.calculated_posttax_total = item.calculated_pretax_total + item.calculated_tax
            item.calculated_deposit = item.rental_contract_item_charges.find((charge) => charge.charge_type === 'DEPOSIT').actual_cost
        })
    }

    const check_checklist = (checklist) => {
        if (myOrder !== undefined) {
            for (const item of myOrder.rental_contract_items) {
                if (item.status !== 'CANCELED') {
                    const item_checklist = item[checklist]
                    if ('odometer_reading' in item_checklist && (item_checklist.odometer_reading === undefined || item_checklist.odometer_reading === null))
                        return false
                    if ('questions' in item_checklist) {
                        for (let question_index in item_checklist.questions) {
                            if (item_checklist.questions[question_index].answer === undefined || item_checklist.questions[question_index].answer === null)
                                return false
                        }
                    }
                }
            }
            return true
        }
        return false
    }
    const check_deposit_status = (invoice) => {
        const currently_paid = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'PAID').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
        const currently_hold = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'HOLD').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
        const currently_processing = (invoice?.invoice_payments || []).filter((item) => ['PROCESSING', 'LINK-SENT'].includes(item.status)).length > 0
        return !currently_processing && invoice?.deposit === currently_paid + currently_hold
    }
    const check_payment_status = (invoice) => {
        const currently_paid = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'PAID').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
        const currently_hold = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'HOLD').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
        const currently_processing = (invoice?.invoice_payments || []).filter((item) => ['PROCESSING', 'LINK-SENT'].includes(item.status)).length > 0
        return !currently_processing && invoice?.total_cost === currently_paid && currently_hold === 0
    }
    const checkout_checklist_complete = check_checklist('checkout_data')
    const checkout_payment_complete = myOrder?.status !== 'RESERVED' || check_deposit_status(myOrderInvoice)
    const checkin_checklist_complete = check_checklist('checkin_data')
    const checkin_payment_complete = myOrder?.status !== 'RESERVED' && check_payment_status(myOrderInvoice)
    console.log(checkout_checklist_complete)
    console.log(checkin_checklist_complete)

    return (
        (<Box>
            <LoadingBackdropIndeterminate
                open={contractLoadingStep > 0}
                text={"Loading Order"}
            />
            <LoadingBackdropIndeterminate
                open={contractSavingStep > 0}
                text={"Saving Order"}
            />
            <LoadingBackdropIndeterminate
                open={contractInvoiceStep > 0}
                text={"Generating Invoice"}
            />
            {myOrder && <Box>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Grid container alignItems={"center"}>
                        <Grid size="grow">
                            <Tabs
                                value={tab}
                                onChange={(e, value) => setTab(value)}
                                variant="scrollable"
                                slotProps={{
                                    indicator: { sx: { backgroundColor: '#009be5' } }
                                }}
                            >
                                <Tab label="Details" value="details" sx={{ fontWeight: "bold" }} />
                                <Tab label="Check Out" value="checkoutdata" icon={checkout_payment_complete && checkout_checklist_complete ? <CheckCircleIcon /> : undefined} iconPosition="start" disabled={myOrder.status !== 'RESERVED'} sx={{ fontWeight: "bold" }} />
                                <Tab label="Check In" value="checkindata" icon={checkin_payment_complete ? <CheckCircleIcon /> : undefined} iconPosition="start" disabled={!['CHECKED_OUT', 'CHECKING_IN', 'CHECKED_IN'].includes(myOrder.status)} sx={{ fontWeight: "bold" }} />
                            </Tabs >
                        </Grid>
                        <Grid size="auto">
                            {['RESERVED'].includes(myOrder.status) && <Button variant="contained" color="primary" onClick={() => checkout_update()} sx={{ mr: 0.5 }}>Save</Button>}
                            {['RESERVED'].includes(myOrder.status) && <Button variant="outlined" color="error" onClick={() => cancelOrder()} sx={{ mr: 0.5 }}>Cancel Contract</Button>}
                            {['CHECKED_OUT', 'CHECKING_IN', 'CHECKED_IN'].includes(myOrder.status) && <Button variant="contained" color="primary" onClick={() => checkin_update()} sx={{ mr: 0.5 }}>Save</Button>}
                        </Grid>
                    </Grid>
                </Box>
                <TabPanel value={tab} value_key={"details"}>
                    <Grid container spacing={1} sx={{ pb: '5px' }} alignItems="center">
                        <Grid size="auto">
                            <Box sx={{ padding: "3px 8px 3px 8px", backgroundColor: theme.palette[RENTAL_CONTRACT_COLOR_MAP[myOrder.status] || 'primary'].main }}>
                                <b>
                                    <span key="contract">Contract #{myOrder.id}</span>
                                    <br />
                                    <span key="status">Status: {RENTAL_STATUS_FRIENDLY_NAMES[myOrder.status]}</span>
                                </b>
                            </Box>
                        </Grid>
                        <Grid size="grow">

                            <ButtonGroup color='primary' variant='contained'>
                                <Button onClick={generatePdf}>Invoice</Button>
                                <Button sx={{ p: '6px' }} onClick={openInvoiceOptionsMenu}><ArrowDropDownIcon /></Button>
                            </ButtonGroup>
                            <Menu
                                id={'invoiceoptionsmenu'}
                                anchorEl={invoiceOptionsMenuAnchorElement}
                                open={invoiceOptionsMenuItemOpen}
                                onClose={() => setInvoiceOptionsMenuItemOpen(false)}
                                slotProps={{
                                    list: {
                                        'aria-labelledby': 'basic-button',
                                    }
                                }}
                            >
                                <MenuItem disabled={!myOrder.customer.email} onClick={generatePdf}>Send As Email ({myOrder.customer.email ? myOrder.customer.email : "NO EMAIL"})</MenuItem>
                            </Menu>
                        </Grid>
                    </Grid>
                    <CustomerAccordion
                        customer={myOrder.customer}
                        default_expanded={false}
                    />
                    <Box>
                        <Grid container spacing={4}>
                            <Grid size={6}>
                                <Grid spacing={1} container alignItems={"center"}>
                                    <Grid size="auto">
                                        <h3>Date & Time</h3>
                                    </Grid>
                                    <Grid size="grow">
                                        <Button disabled={myOrder.status !== 'RESERVED'} onClick={(e) => { editOrderTime() }}>
                                            <ModeEditIcon /> <Box sx={{ pl: 1 }}>Edit</Box>
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            {['RESERVED'].includes(myOrder.status) &&
                                                <AccessTimeIcon />
                                            }
                                            <span>Out: {calculated_start_date.local().format('ddd, D MMM YYYY h:mm A')}</span>
                                        </Grid>
                                        <Grid item>
                                            {['RESERVED', 'CHECKED_OUT'].includes(myOrder.status) &&
                                                <AccessTimeIcon />
                                            }
                                            <span>In: {calculated_end_date.local().format('ddd, D MMM YYYY h:mm A')}</span>
                                        </Grid>
                                        <Grid item>
                                            {['RESERVED', 'CHECKED_OUT'].includes(myOrder.status) &&
                                                <AccessTimeIcon />
                                            }
                                            <span>{Math.floor((calculated_end_date - calculated_start_date) / (1000 * 60 * 60 * 24))} days, {Math.floor((calculated_end_date - calculated_start_date) / (1000 * 60 * 60)) % 24} hrs</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={6}>
                                <h3>Payment</h3>
                                <Grid container spacing={3}>
                                    <Grid item>
                                        <Grid container direction={"column"}>
                                            <Grid item>
                                                <span>Contract Total:</span>
                                            </Grid>
                                            <Grid item>
                                                <span>Deposit Total:</span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction={"column"}>
                                            <Grid item>
                                                <span>${moneyFormat(order_total)}</span>
                                            </Grid>
                                            <Grid item>
                                                <span>${moneyFormat(deposit_total)}</span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* {myOrder.status === 'CHECKED_OUT' &&
                            <Grid container alignItems="center" spacing={1}>
                                <Grid xs>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="hourscharged"
                                        label="Hours Charged"
                                        type="number"
                                        fullWidth
                                        variant="standard"
                                        disabled={!allowEditingHours || myOrder.status !== 'CHECKED_OUT'}
                                        value={myOrder.status !== 'CHECKED_OUT' ? undefined : reservation_length}
                                        onChange={(event) => setChargedHours(Math.max(1, (parseInt(event.target.value) || 0)))}
                                        InputProps={{
                                            inputProps: { min: 1 },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {<AccessTimeIcon />}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid xs>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={allowEditingHours}
                                                onChange={() => setAllowEditingHours(!allowEditingHours)}
                                                disabled={myOrder.status !== 'CHECKED_OUT'}
                                            />
                                        }
                                        label="Edit Hours Charged?"
                                    />
                                </Grid>
                            </Grid>
                        } */}
                    </Box>
                    <Grid container spacing={3} alignItems="center">
                        <Grid size="auto">
                            <h2>Items ({myOrder.rental_contract_items.length})</h2>
                        </Grid>
                        {['RESERVED'].includes(myOrder.status) &&
                            <Grid size="grow">
                                <Button variant="contained" disabled>
                                    <AddShoppingCartIcon /> <Box sx={{ pl: 1 }}>Add To Contract</Box>
                                </Button>
                            </Grid>
                        }
                    </Grid>
                    {myOrder.rental_contract_items.map((item) => (
                        <ContractItem
                            item={item}
                            rentalItem={myOrderItems[item.rental_item_id]}
                            setAdjustmentModal={setAdjustmentModal}
                            refresh_function={() => setOrder(undefined)}
                            cancelItem={cancelItem}
                            closeEditQuantityModal={closeEditQuantityModal}
                        />
                    ))}
                </TabPanel>
                <TabPanel value={tab} value_key={"checkoutdata"}>
                    <Grid container spacing={1} alignItems={"center"}>
                        <Grid size="auto">
                            <ToggleButtonGroup
                                color="primary"
                                value={checkoutTab}
                                exclusive
                                onChange={(e, newValue) => { if (newValue) setCheckoutTab(newValue) }}
                                aria-label="CheckoutTab"
                            >
                                <ToggleButton value="data">{checkout_checklist_complete ? <span style={{ display: 'contents' }}><CheckCircleIcon /><Box sx={{ pl: 1 }}>Data</Box></span> : "Data"}</ToggleButton>
                                <ToggleButton value="payment">Payment</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid size="grow">
                            <Button variant="contained" disabled={!checkout_payment_complete || myOrder.status !== 'RESERVED'} color="success" onClick={() => checkout_complete()} sx={{ mr: 0.5 }}>Check Out</Button>
                        </Grid>
                    </Grid>
                    <TabPanel value={checkoutTab} value_key={"data"}>
                        {myOrder.rental_contract_items.filter(filterCanceledItems).map((item) => (
                            <ContractItemData
                                item={item}
                                itemData={rentalContractItems[item.id]}
                                rentalItem={myOrderItems[item.rental_item_id]}
                                updateOdometerReading={updateOdometerReading}
                                updateQuestion={updateQuestion}
                                updateFeeOptional={updateFeeOptional}
                                updateFeeRefunded={updateFeeRefunded}
                                data_key={'checkout_data'}
                                refresh_function={() => setOrder(undefined)}
                            />
                        ))}
                    </TabPanel>
                    <TabPanel value={checkoutTab} value_key={"payment"}>
                        <PaymentPage
                            open={checkoutTab === "payment"}
                            invoice={myOrderInvoice}
                            location_id={myOrder.location_id}
                            sendUpdate={paymentUpdate}
                        />
                    </TabPanel>
                </TabPanel>
                <TabPanel value={tab} value_key={"checkindata"}>
                    <Grid container spacing={1} alignItems={"center"}>
                        <Grid size="auto">
                            <ToggleButtonGroup
                                color="primary"
                                value={checkinTab}
                                exclusive
                                onChange={(e, newValue) => { if (newValue) setCheckinTab(newValue) }}
                                aria-label="CheckinTab"
                            >
                                <ToggleButton value="data">{checkin_checklist_complete ? <span style={{ display: 'contents' }}><CheckCircleIcon /><Box sx={{ pl: 1 }}>Data</Box></span> : "Data"}</ToggleButton>
                                <ToggleButton value="payment">Payment</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid size="grow">
                            {myOrder.status === 'CHECKED_OUT' &&
                                <Button variant="contained" color="error" onClick={() => checkin_start()} sx={{ mr: 0.5 }}>Stop Clock</Button>
                            }
                            {myOrder.status === 'CHECKING_IN' &&
                                <Button variant="contained" color="success" onClick={() => checkin_complete()} sx={{ mr: 0.5 }}>Check In</Button>
                            }
                        </Grid>
                    </Grid>
                    <TabPanel value={checkinTab} value_key={"data"}>
                        {myOrder.rental_contract_items.filter(filterCanceledItems).map((item) => (
                            <ContractItemData
                                item={item}
                                itemData={rentalContractItems[item.id]}
                                rentalItem={myOrderItems[item.rental_item_id]}
                                updateOdometerReading={updateOdometerReading}
                                updateQuestion={updateQuestion}
                                updateFeeOptional={updateFeeOptional}
                                updateFeeRefunded={updateFeeRefunded}
                                data_key={'checkin_data'}
                                refresh_function={() => setOrder(undefined)}
                            />
                        ))}
                    </TabPanel>
                    <TabPanel value={checkinTab} value_key={"payment"}>
                        <PaymentPage
                            open={checkinTab === "payment"}
                            invoice={myOrderInvoice}
                            rentalcontract={myOrder}
                            sendUpdate={paymentUpdate}
                        />
                    </TabPanel>
                </TabPanel>
                {editingDate &&
                    <ContractEditDateModal
                        contract={myOrder}
                        rentalItems={myOrderItems}
                        open={editingDate}
                        closeModal={closeEditDateModal}
                    />
                }
                <ContractAdjustmentModal
                    open={adjustmentModal.open}
                    rentalContractItem={adjustmentModal.rentalContractItem}
                    closeModal={closeAdjustmentModal}
                />
            </Box>}
        </Box >)
    );
}
